// src/services/webinarsService.js
import apiClient from './apiClient.js'

export const webinarsService = {
    getWebinars(params = {}) {
        return apiClient.get('/webinars', { params })
    },

    getWebinarBySlug(slug) {
        return apiClient.get(`/webinars/${slug}`)
    },

    registerForWebinar(slug, data) {
        return apiClient.post(`/webinars/${slug}/register`, data)
    },

    createWebinar(data) {
        return apiClient.post('/webinars', data)
    },

    updateWebinar(id, data) {
        return apiClient.put(`/webinars/${id}`, data)
    },

    deleteWebinar(id) {
        return apiClient.delete(`/webinars/${id}`)
    },

    getWebinarRegistrations(slug, params = {}) {
        return apiClient.get(`/webinars/${slug}/registrations`, { params })
    },
}